import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { StatusBadge, ErrorMsg } from './ui';

export default function AlertStudents({ alert, id }) {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    api.get('/reports/host-specialist/students', { params: { type: alert.type, key: alert.key } })
      .then(res => { if (!cancelled) setStudents(res.data); })
      .catch(() => { if (!cancelled) setError('Could not load these students. Close and reopen the list to retry.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [alert.type, alert.key]);

  const prospectsQuery = new URLSearchParams({ [alert.type === 'program' ? 'program' : 'city']: alert.key });
  return (
    <div id={id} className="hs-alert-students">
      <div className="hs-student-heading">
        <div>
          <strong>{alert.label} — students needing placement</strong>
          <div className="sub">Next 30 days · earliest start first. A student may appear in both a program and city alert.</div>
        </div>
        <Link className="hs-alert-cta" to={`/host-prospects?${prospectsQuery}`}>View host prospects</Link>
      </div>
      {loading ? <p role="status">Loading students…</p> : error ? <ErrorMsg>{error}</ErrorMsg> : (
        <div className="table-wrap">
          <table className="tbl">
            <thead><tr><th>Student</th><th>Contact</th><th>Program / City</th><th>Practicum needed</th><th>Status</th><th>PC</th></tr></thead>
            <tbody>
              {students.map(s => (
                <tr key={s.id}>
                  <td><Link to={`/students/${s.id}`}>{s.first_name} {s.last_name}</Link></td>
                  <td>
                    {s.email && <div><a href={`mailto:${s.email}`}>{s.email}</a></div>}
                    {s.phone && <div><a href={`tel:${s.phone}`}>{s.phone}</a></div>}
                    {!s.email && !s.phone && '—'}
                  </td>
                  <td>{s.program_name}<div className="sub">{s.city || '—'}</div></td>
                  <td>{new Date(`${s.practicum_start_date.slice(0, 10)}T12:00:00`).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                  <td><StatusBadge status={s.status} /></td>
                  <td>{s.pc_name || 'Unassigned'}</td>
                </tr>
              ))}
              {students.length === 0 && <tr><td colSpan={6}>No matching students currently. Placement status may have changed since this alert loaded.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
